/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_OEM_ADMIN_ECU_REQUEST,
  FETCH_OEM_ADMIN_ECU_SUCCESS,
  FETCH_OEM_ADMIN_ECU_FAILURE,
} from "./OemAdminEcuTypes";

const initialState = {
  loading: false,
  ecu: [],
  error: "",
};

const OemAdminEcuReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OEM_ADMIN_ECU_REQUEST:
      return {
        ...state,
        loading: true,
      };

      case FETCH_OEM_ADMIN_ECU_SUCCESS:
        if (JSON.stringify(state.ecu) === JSON.stringify(action.payload)) {
          return { ...state, loading: false, error: "" };
        }
        return {
          ...state,
          loading: false,
          ecu: action.payload,
          error: "",
        };
    case FETCH_OEM_ADMIN_ECU_FAILURE:
      return {
        loading: false,
        ecu: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default OemAdminEcuReducer;
